import React, { useEffect, useRef } from "react";
import { createPolicyConfig } from "../../../redux/slice/policy/policySlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

const PolicyPreview = ({ modal_id, data, policyCreateCloseRef }) => {
  const { gl_accounts } = useSelector((state) => state.accounting);
  const { cover } = useSelector((state) => state.policy);
  const { all_covers } = useSelector((state) => state.cover);
  const { offices } = useSelector((state) => state.office?.offices);
  const chargesList = ["ID Card", "Passport", "License", "TIN"];

  const appliedToOffice = offices?.filter((item) => item.id === data?.rab);

  const accountKeys = data?.p_account && Object.keys(data?.p_account);
  const glAccountsKeys = gl_accounts && Object.keys(gl_accounts?.accounts);

  const dispatch = useDispatch();

  return (
    <>
      <div
        id={modal_id}
        class='modal fade '
        tabindex='-1'
        role='dialog'
        aria-labelledby='fullWidthModalLabel'
        aria-hidden='true'
      >
        <div
          class='modal-dialog modal-full-width'
          style={{ maxWidth: "750px" }}
        >
          <div class='modal-content rounded-4'>
            <div class='modal-header'>
              <h4 class='modal-title text-primary-1' id='fullWidthModalLabel'>
                Preview Policy
              </h4>
              <button
                type='button'
                class='btn-close'
                data-bs-dismiss='modal'
                aria-hidden='true'
                data-backdrop='false'
                ref={policyCreateCloseRef}
              ></button>
            </div>
            <div class='modal-body'>
              <div className='row'>
                <div className='col-md-6 mb-2 '>
                  <label htmlFor='' className='form-labe mt-1'>
                    Name
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.p_general_information?.name}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
                <div className='col-md-6 mb-2'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Policy Code
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.p_general_information?.short_name}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-2'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Currency
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.p_general_information?.currency}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
                <div className='col-md-6 mb-2'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Minimum Duration(months)
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.p_general_information?.minimun_duration}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-2'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Minimum age
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.p_general_information?.minimum_age}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
                <div className='col-md-6 mb-2'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Maximum Age
                  </label>
                  <input
                    type='text'
                    defaultValue={data?.p_general_information?.maximum_age}
                    className='form-control form-control-sm'
                    readOnly
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <label htmlFor='' className='form-labe mt-1'>
                    Description{" "}
                  </label>
                  <div>
                    <textarea
                      name=''
                      id=''
                      cols='30'
                      className='form-control form-control-sm'
                      rows='3'
                      readOnly
                      defaultValue={data?.p_general_information?.description}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div>
                <h5 className='mt-3 fw-bolder text-primary-1'>Cover</h5>
                <div className='row'>
                  {data?.p_cover?.map((p_cover, i) => {
                    const matchingCover = cover?.get_covers?.find(
                      (cover) => parseInt(cover.id) == p_cover
                    );

                    return (
                      matchingCover && (
                        <p className='my-1' key={i}>
                          {i + 1}. {matchingCover.cover_name}
                        </p>
                      )
                    );
                  })}
                </div>
              </div>
              <div>
                <h5 className='mt-3 fw-bolder text-primary-1'>Rate</h5>
                <div className='row'>
                  <div className='col-md-4 mb-2'>
                    <label htmlFor='' className='form-labe mt-1'>
                      Default rate
                    </label>
                    <input
                      type='text'
                      defaultValue={data?.p_interest?.default_interest_rate}
                      className='form-control form-control-sm'
                      readOnly
                    />
                  </div>
                  <div className='col-md-4 mb-2'>
                    <label htmlFor='' className='form-labe mt-1'>
                      Minimum rate
                    </label>
                    <input
                      type='text'
                      defaultValue={data?.p_interest?.minimum_interest_rate}
                      className='form-control form-control-sm'
                      readOnly
                    />
                  </div>
                  <div className='col-md-4 mb-2'>
                    <label htmlFor='' className='form-labe mt-1'>
                      Maximum rate
                    </label>
                    <input
                      type='text'
                      defaultValue={data?.p_interest?.maximum_interest_rate}
                      className='form-control form-control-sm'
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div>
                <h5 className='mt-3 fw-bolder text-primary-1'>Account</h5>
                {accountKeys ? (
                  accountKeys?.map((item, i) => {
                    if (data?.p_account[item]) {
                      let gl_acc = glAccountsKeys?.map(
                        (el) => gl_accounts?.accounts[el]
                      );
                      const flattenedGlAcc = [].concat(...gl_acc);

                      let accountName = flattenedGlAcc
                        ?.map((el) => {
                          if (data?.p_account[item] === el?.id) {
                            return el?.account_name;
                          }
                        })
                        .filter((element) => element !== undefined);

                      return (
                        <div className='row' key={i}>
                          <div className='col-md-4 mb-2'>
                            <label
                              htmlFor=''
                              className='form-labe mt- text-capitalize'
                            >
                              {item?.split("_")[0]}
                            </label>
                            <input
                              type='text'
                              defaultValue={accountName[0]}
                              className='form-control form-control-sm'
                              readOnly
                            />
                          </div>
                        </div>
                      );
                    }
                  })
                ) : (
                  <p className='alert alert-warning '>No Account Selected</p>
                )}
              </div>
              <div>
                <h5 className='mt-3 fw-bolder text-primary-1'>Charges</h5>
                <div className='row'>
                  <div className='col-md-12'>
                    <div className='charges'>
                      {data?.charges?.length ? (
                        data?.charges?.map((item, i) => (
                          <span
                            className='bg-primary text-light fs-6'
                            style={{ padding: "4px", margin: "0px 4px" }}
                            key={i}
                          >
                            {item.label}
                          </span>
                        ))
                      ) : (
                        <p className='alert alert-warning '>
                          No charges selected
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className=''>
                <h5 className='mt-3 fw-bolder text-primary-1'>
                  Apply to Office(s)
                </h5>
                {data?.apply_to === "CW" && (
                  <>
                    {/* <strong>Apply to: </strong> */}
                    <span>Company Wide</span>
                  </>
                )}
                {data?.apply_to === "SO" && (
                  <div className='mb-1'>
                    <strong>Specific Offices: </strong>
                    <div>
                      {data?.specific_offices && data?.apply_to === "SO"
                        ? data?.specific_offices?.map((item, i) => (
                            <span
                              className='bg-primary text-light fs-6'
                              style={{ padding: "4px", margin: "0px 4px" }}
                              key={i}
                            >
                              {item.label}
                            </span>
                          ))
                        : null}
                    </div>
                  </div>
                )}
                {data?.apply_to === "RAB" && (
                  <>
                    <div className='mb-1'>
                      <strong>Region/Area/Branch: </strong>
                      <span>{appliedToOffice[0]?.office_name}</span>
                    </div>
                    <div className='mb-1'>
                      <strong>Apply to Sub-offfices: </strong>
                      <span>{data?.apply_sub_offices ? "Yes" : "No"}</span>
                    </div>
                  </>
                )}
              </div>
              {data?.expires_at && (
                <div className='row'>
                  <h5 className='mt-3 fw-bolder text-primary-1'>Expires At</h5>
                  <span>{moment(data?.expires_at).format("LL")}</span>
                </div>
              )}
            </div>

            <div class='modal-footer'>
              <button
                type='button'
                class='btn btn-light'
                data-bs-dismiss='modal'
              >
                Close
              </button>
              <button
                type='button'
                class='btn btn-primary'
                onClick={() => {
                  const {
                    p_general_information,
                    p_account,
                    p_interest,
                    p_cover,
                    payload,
                    policy_cat_id,
                  } = data;
                  dispatch(
                    createPolicyConfig({
                      p_general_information,
                      p_account,
                      p_interest,
                      p_cover,
                      policy_cat_id,
                      ...payload,
                    })
                  );
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PolicyPreview;
